var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"tg-marquee",attrs:{"type":"flex","justify":"start","align":"start"}},[_c('tg-marquee-icon'),_c('marquee',{attrs:{"onmouseover":"this.stop();","onmouseout":"this.start();"},domProps:{"innerHTML":_vm._s(_vm.marquee)}},[_vm._v(_vm._s(_vm.marquee))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }